import decodeHTMLEntities from './decode-html-entities.util';
export default function (htmlList) {
  const regExp = /<li>([^<]+)<\/li>/g;
  let match = regExp.exec(htmlList);
  const array = [];
  while (match != null) {
    // @todo. auto generated. fix this error
    // @ts-ignore
    array.push(match[1]);
    match = regExp.exec(htmlList);
  }
  return array.map(decodeHTMLEntities);
}